const ArrowLeftGifting = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3905 24.9427C11.8698 24.422 11.8698 23.5778 12.3905 23.0571L19.4477 15.9999L12.3905 8.94273C11.8698 8.42203 11.8698 7.57781 12.3905 7.05711C12.9112 6.53641 13.7554 6.53641 14.2761 7.05711L22.2761 15.0571C22.7968 15.5778 22.7968 16.422 22.2761 16.9427L14.2761 24.9427C13.7554 25.4634 12.9112 25.4634 12.3905 24.9427Z" />
    </svg>
  )
}

export default ArrowLeftGifting
